import { useSocketEvent, useSocketState } from '../helpers/useSocket'
import { countdownRenderer } from '../helpers/countdownRenderer'
import { DraftCiv } from '../components/DraftCiv'
import { DraftMap } from '../components/DraftMap'
import { mergeCivDraftView, mergeMapDraftView } from '../helpers/mergeDraftView'
import React, { useState, useEffect } from 'react'
import Countdown from 'react-countdown'
import { MatchGame } from '../components/MatchGame'
import { MatchGameDraft } from '../components/MatchGameDraft'
import colors from '../config/colors.json'

export default function AltDraftDisplay() {
	const [config, setConfig] = useState({ cssTheme: 'default.css' })
	const [match] = useSocketState('Match')
	const [civDraft] = useSocketState('CivDraft')
	const [mapDraft] = useSocketState('MapDraft')
	const [gameCivDraft] = useSocketState('GameCivDraft')
	const [tournament] = useSocketState('Tournament')
	const [themeConfig, setThemeConfig] = useState(null)

	const civDraftView = civDraft && match ? mergeCivDraftView(civDraft?.view || {}, match.games, match.matchRedraftAfter) : {}
	const mapDraftView = mapDraft && match ? mergeMapDraftView(mapDraft?.view || {}, match.games, 0) : {}
	const _gameCivDraftView = gameCivDraft ? mergeCivDraftView(gameCivDraft?.view || {}, [], 0) : {}

	let leftPlayerInfo = tournament?.config?.players?.find((p) => match.leftPlayer.name.toLowerCase().includes(p.name.toLowerCase()))
	let rightPlayerInfo = tournament?.config?.players?.find((p) => match.rightPlayer.name?.toLowerCase().includes(p.name.toLowerCase()))

	useSocketEvent('updateConfig', (newdata) => {
		console.log(`Received updateConfig`, newdata)
		setConfig(newdata)
	})

	useEffect(() => {
		const themeName = config.theme ?? config.cssTheme?.replace('.css', '.json')
		if (!themeName) return
		fetch(`/themes/${themeName}`)
			.then((r) => r.json())
			.then(setThemeConfig)
			.catch(() => setThemeConfig(null))
	}, [config.theme, config.cssTheme])

	const theme = themeConfig?.draftDisplay ?? {}
	const showRoundInfo = theme.showRoundInfo ?? true
	const showStatus = theme.showStatus ?? true
	const showTeamIcon = theme.showTeamIcon ?? true
	const showCasterNames = theme.showCasterNames ?? true
	const draftType = theme.draftType ?? 'allPicks'
	const showMapDraft = theme.showMapDraft ?? true
	const showMapNames = theme.showMapNames ?? false
	const showCivNames = theme.showCivNames ?? false
	const showAdminBans = theme.showAdminBans ?? false
	const civDisplayType = theme.civDisplayType ?? 'normal'

	const cssFiles = themeConfig?.css ?? (config.cssTheme ? [config.cssTheme] : [])
	const cssVars = Object.fromEntries(Object.entries(themeConfig?.cssVariables ?? {}).map(([k, v]) => [k.startsWith('--') ? k : `--${k}`, v]))

	return (
		<div
			className="altDraft"
			style={{
				'--left-player-color': colors[match?.leftPlayer?.color]?.mainColor,
				'--left-player-color-secondary': colors[match?.leftPlayer?.color]?.secondaryColor,
				'--left-player-color-alpha': colors[match?.leftPlayer?.color]?.mainColorAlpha,
				'--left-player-color-alpha7': colors[match?.leftPlayer?.color]?.mainColorAlpha7,
				'--right-player-color': colors[match?.rightPlayer?.color]?.mainColor,
				'--right-player-color-secondary': colors[match?.rightPlayer?.color]?.secondaryColor,
				'--right-player-color-alpha': colors[match?.rightPlayer?.color]?.mainColorAlpha,
				'--right-player-color-alpha7': colors[match?.rightPlayer?.color]?.mainColorAlpha7,
				...cssVars,
			}}>
			{cssFiles.map((css) => (
				<link key={css} rel="stylesheet" type="text/css" href={`/themes/${css}`} />
			))}
			{match && (
				<div className="upcoming__game__names">
					<span className="draft__playerInfo draft__playerInfo-left flex flex-row">
						<h1 className="draft__name draft__leftName">{match.leftPlayer.name}</h1>
						{leftPlayerInfo?.teamPictureUrl && <img src={leftPlayerInfo?.teamPictureUrl} className="draft__teamIcon draft__leftTeamIcon" alt="" />}
					</span>

					<span className="draft__playerInfo draft__playerInfo-right flex flex-row">
						{rightPlayerInfo?.teamPictureUrl && <img src={rightPlayerInfo?.teamPictureUrl} className="draft__teamIcon draft__rightTeamIcon" alt="" />}
						<h1 className="draft__name draft__rightName">{match.rightPlayer.name}</h1>
					</span>
				</div>
			)}

			{match?.countdownTimer && (
				<div className="match__countdown">
					<Countdown date={match.countdownTimer} renderer={countdownRenderer} />
				</div>
			)}
			{match?.games && (
				<>
					<div className="upcoming__game">
						{match.games
							.filter((game) => game.state === 'upcoming')
							.map((game, i) => (
								<MatchGameDraft key={i} game={game} />
							))}
					</div>
				</>
			)}
		</div>
	)
}
